<!-- Do not change this file. -->
<template>
  <div class="d-flex flex-column h-100">
    <EnvLabel />
    <div>
      <TheHeader />
      <TheNavbar />
    </div>
    <div class="flex-grow-1 py-5" :class="backgroundClass" role="main">
      <SessionHandler />
    </div>
    <TheFooter />
  </div>
</template>

<script>
/* Do not change this file. */

import TheHeader from "@/components/core/TheHeader.vue";
import TheFooter from "@/components/core/TheFooter.vue";
import TheNavbar from "@/components/core/TheNavbar.vue";
import EnvLabel from "@/components/core/EnvLabel.vue";
import SessionHandler from "@/components/core/SessionHandler.vue";

import config from "@/data/config";
import { mapActions } from "vuex";

export default {
  name: "App",
  data() {
    return {
      backgroundClass: config.appStyle.backgroundClass
    };
  },
  components: {
    EnvLabel,
    TheHeader,
    TheNavbar,
    TheFooter,
    SessionHandler
  },
  methods: {
    ...mapActions(["setHash"])
  },
  created() {
    this.setHash(window.location.hash);
  }
};
</script>
